const e = [
  {
    id: "name",
    lang: "ru",
    errorMessage: "Укажите полное наименование",
    charset: "REDS",
    inputText: "Введите название",
    inputWidth: 492,
    labelWidth: 492,
    labelLineCount: 1,
    type: "string",
    name: "Название",
    regexp: '^[a-zA-Zа-яА-Я0-9Ёё«»<>№—“`‚"‘’“”„–‒ .?,"`~\'![\\]{\\}()@#^$%:;&%*+|/_\\-\\=\\\\]+$'
  },
  {
    id: "vendorCode",
    lang: "ru",
    errorMessage: "Укажите артикул",
    charset: "EDS",
    inputText: "Артикул",
    inputWidth: 200,
    labelWidth: 200,
    labelLineCount: 1,
    type: "string",
    name: "Артикул",
    required: !1
  },
  {
    id: "category",
    lang: "ru",
    errorMessage: "Введите название категории",
    charset: "REDS",
    inputText: "Категория",
    inputWidth: 200,
    labelWidth: 200,
    labelLineCount: 1,
    type: "list",
    values: ["Мебель", "Электроника", "Услуги", "Прочее"],
    ownVariant: !0,
    name: "Категория",
    required: !1
  },
  {
    id: "unit",
    lang: "ru",
    errorMessage: "Укажите еденицы измерения",
    charset: "REDS",
    inputText: "шт.",
    inputWidth: 150,
    labelWidth: 150,
    labelLineCount: 1,
    type: "list",
    values: ["шт.", "л", "кг", "м", "г"],
    ownVariant: !0,
    name: "Еденица измерения",
    required: !1
  },
  {
    id: "description",
    lang: "ru",
    errorMessage: "Введите описание",
    charset: "REDS",
    inputText: "Введите описание",
    inputWidth: 492,
    labelWidth: 492,
    labelLineCount: 1,
    type: "string",
    name: "Описание",
    required: !1,
    /* eslint-disable */
    regexp: '^[a-zA-Zа-яА-Я0-9Ёё«»<>№—“`‚"‘’“”„–‒ .?,"`~\'![\\]{\\}()@#^$%:;&%*+|/_\\-\\=\\\\]+$'
  },
  {
    id: "price",
    lang: "ru",
    errorMessage: "Введите цену числом",
    // charset: 'DS',
    inputText: "₽",
    inputWidth: 200,
    labelWidth: 200,
    labelLineCount: 1,
    type: "money",
    name: "Цена",
    required: !1
  },
  {
    id: "VAT",
    lang: "ru",
    errorMessage: "Введите число",
    charset: "DS",
    inputText: "%",
    inputWidth: 200,
    labelWidth: 200,
    labelLineCount: 1,
    type: "decimal",
    name: "% НДС",
    required: !1
  },
  {
    id: "discountPercent",
    lang: "ru",
    errorMessage: "Введите число",
    // charset: 'DS',
    inputText: "%",
    inputWidth: 200,
    labelWidth: 200,
    labelLineCount: 1,
    type: "decimal",
    name: "Скидка на позицию товара в %",
    required: !1
  },
  {
    id: "discountCost",
    lang: "ru",
    errorMessage: "Введите число",
    charset: "DS",
    inputText: "₽",
    inputWidth: 200,
    labelWidth: 200,
    labelLineCount: 1,
    type: "money",
    name: "Скидка на позицию товара в деньгах",
    required: !1
  }
], t = [
  {
    id: "number",
    name: "№",
    width: "35px",
    readOnly: !0
  },
  {
    id: "name",
    name: "Название",
    width: "205px"
  },
  {
    id: "vendorCode",
    name: "Артикул",
    width: "110px"
  },
  {
    id: "category",
    name: "Категория",
    canApplyToAll: !0,
    width: "135px"
  },
  {
    id: "description",
    name: "Описание",
    width: "220px"
  },
  {
    id: "count",
    name: "Кол-во",
    width: "35px",
    canApplyToAll: !0,
    type: "count"
  },
  {
    id: "unit",
    name: "Ед. изм.",
    width: "35px",
    canApplyToAll: !0
  },
  {
    id: "price",
    name: "Цена, руб.",
    width: "80px",
    type: "money"
  },
  {
    id: "VAT",
    name: "НДС %",
    width: "74px",
    canApplyToAll: !0,
    type: "percentage",
    maxLength: 2
  },
  {
    id: "discountPercent",
    name: "Скидка на позицию %",
    width: "95px",
    canApplyToAll: !0,
    type: "percentage",
    maxLength: 2
  },
  {
    id: "discountCost",
    name: "Скидка на позицию, руб.",
    width: "120px",
    canApplyToAll: !0,
    type: "money"
  },
  {
    id: "VATWithDiscount",
    name: "НДС с учетом скидок, руб.",
    width: "95px",
    type: "money",
    readOnly: !0
  },
  {
    id: "priceWithDiscount",
    name: "Стоимость ед. с учетом скидок, руб.",
    width: "125px",
    type: "money"
  },
  {
    id: "priceItemsWithDiscount",
    name: "Общая стоимость с уч. скидок, руб.",
    width: "125px",
    type: "money"
  }
], i = [
  {
    id: "totalDiscountPercent",
    name: "Скидка общая %",
    type: "percentage"
  },
  {
    id: "totalDiscountCost",
    name: "Скидка общая, руб.",
    type: "money"
  },
  {
    id: "totalCountItems",
    name: "Количество позиций",
    readOnly: !0
  },
  {
    id: "totalDicountCostItem",
    name: "Скидка на каждую единицу, руб.",
    type: "money",
    readOnly: !0
  },
  {
    id: "totalVAT",
    name: "Итого НДС, руб.",
    type: "money",
    readOnly: !0
  },
  {
    id: "totalPrice",
    name: "Итого, руб.",
    type: "money",
    readOnly: !0
  }
], n = [
  {
    id: "showTotalRow",
    name: "Итоги прописью",
    readOnly: !0,
    defaultEnabled: !0
  }
], s = {
  ".bmp": "/icons/file_types/bmp.svg",
  ".csv": "/icons/file_types/csv.svg",
  ".dg2": "/icons/file_types/dg2.svg",
  ".dgr": "/icons/file_types/dgr.svg",
  ".doc": "/icons/file_types/doc.svg",
  ".docx": "/icons/file_types/docx.svg",
  ".forma": "/icons/file_types/forma.svg",
  ".gif": "/icons/file_types/gif.svg",
  ".jpg": "/icons/file_types/jpg.svg",
  ".jpeg": "/icons/file_types/jpg.svg",
  ".key": "/icons/file_types/keynote.svg",
  ".keynote": "/icons/file_types/keynote.svg",
  ".numbers": "/icons/file_types/numbers.svg",
  ".pages": "/icons/file_types/pages.svg",
  ".pdf": "/icons/file_types/pdf.svg",
  ".png": "/icons/file_types/png.svg",
  ".ppt": "/icons/file_types/ppt.svg",
  ".pptx": "/icons/file_types/pptx.svg",
  ".tif": "/icons/file_types/tif.svg",
  ".tiff": "/icons/file_types/tif.svg",
  ".txt": "/icons/file_types/txt.svg",
  ".xls": "/icons/file_types/xls.svg",
  ".xlsx": "/icons/file_types/xlsx.svg",
  ".zip": "/icons/file_types/zip.svg",
  other: "/icons/file_types/other.svg"
}, p = {
  images: {
    "image/bmp": [".bmp"],
    "image/png": [".png"],
    "image/gif": [".gif"],
    "image/jpeg": [".jpg", ".jpeg"],
    "image/webp": [".webp"],
    "image/tiff": [".tif", ".tiff"]
  },
  documents: {
    "application/msword": [".doc"],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
    "application/vnd.ms-excel": [".xls"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    "application/vnd.oasis.opendocument.spreadsheet": [".ods"],
    "application/vnd.oasis.opendocument.text": [".odt"],
    "application/pdf": [".pdf"],
    "application/rtf": [".rtf"],
    "text/plain": [".txt"]
  },
  archives: {
    "application/zip": [".zip"],
    "application/vnd.rar": [".rar"]
  }
}, a = [
  // 'I',
  "R",
  "D",
  // 'V',
  "T"
  //  'P'
], o = [
  "A",
  "B",
  "C",
  "D",
  "E"
], l = [
  "P",
  "B"
], r = {
  productTattrs: e,
  productTableColumns: t,
  productTableFooter: i,
  productTableConfig: n,
  filesIcons: s,
  fileTypes: p,
  caseItems: a,
  dateItems: o,
  priceItems: l
};
export {
  r as default
};
